import { render, staticRenderFns } from "./call_to_action.vue?vue&type=template&id=bc164424&scoped=true&lang=html"
import script from "./call_to_action.vue?vue&type=script&lang=js"
export * from "./call_to_action.vue?vue&type=script&lang=js"
import style0 from "./call_to_action.vue?vue&type=style&index=0&id=bc164424&prod&lang=css"
import style1 from "./call_to_action.vue?vue&type=style&index=1&id=bc164424&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc164424",
  null
  
)

export default component.exports